import styled from 'styled-components'
import {
  white,
  yellowThr,
  purple,
  black,
  blackSec,
  grayText,
  graySec,
  purpleDark
} from '@qirapagos/lib/theme/colors'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px 0px 48px 0px;
  width: 100%;
  max-width: 1044px;
  background: ${white};
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.09);
  border-radius: 6px;
  margin: 0 auto;
  max-height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
`

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-left: 24px;
`

export const AlertContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 4px;
  width: 206px;
  height: 23px;
  display: none;
`

export const WarningIcon = styled.div`
  width: 23px;
  height: 23px;
  background: ${yellowThr};
  border: 2px solid ${yellowThr};
  border-radius: 50%;
  position: relative;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 32px;
  width: 100%;
  max-width: 996px;
`

export const BalanceSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 32px;
  width: 100%;
`

export const BalanceInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  gap: 4px;
`

export const AmountInputSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 100%;
`

export const RescueAllButton = styled.button`
  background: transparent;
  border: none;
  color: ${purple};
  text-decoration: underline;
  cursor: pointer;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 154.7%;
  margin-top: 0;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  &:hover {
    opacity: 0.8;
  }
`

export const AmountDisplay = styled.input`
  width: 100%;
  height: 80px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 52px;
  line-height: 154.7%;
  text-align: center;
  color: ${blackSec};
  border: none;
  outline: none;
  background: transparent;
  
  &::placeholder {
    color: ${blackSec};
  }
  
  &:focus {
    outline: none;
  }
`

export const DisclaimerSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 24px;
  width: 100%;
`

export const DisclaimerText = styled.div`
  width: 100%;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 154.7%;
  color: ${grayText};
  text-align: left;
  margin-left: 24px;
  align-self: flex-start;
`

export const CheckboxSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 24px;
`

export const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 6px;
  height: 25px;
`

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 20px;
  height: 20px;
  border: 2px solid ${graySec};
  border-radius: 4px;
  appearance: none;
  -webkit-appearance: none;
  outline: none;
  cursor: pointer;
  background-color: #fff;
  transition: all 0.2s ease;

  &:checked {
    background-color: ${purple};
    border-color: ${purpleDark};
    background-image:
      url("data:image/svg+xml;utf8,
      <svg
        fill='white'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 16 16'
      >
      <path
        d='M6.173 13.727L1.045 8.6a1 1 0 011.414-1.414l3.714
        3.714 7.714-7.714a1 1 0 011.414 1.414l-8.428 8.428a1 1 0 01-1.414 0z'
      />
      </svg>");
    background-repeat: no-repeat;
    background-position: center;
  }
`

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 16px;
  width: 273px;
`

export const SubmitButton = styled.button`
  width: 273px;
  height: 53px;
  background: ${purple};
  border-radius: 6px;
  border: none;
  opacity: 0.4;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 154.7%;
  text-align: center;
  color: ${white};
  cursor: pointer;
  
  &:hover {
    opacity: 0.6;
  }
  
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  
  &.enabled {
    opacity: 1;
  }
`

export const styles = {
  titleText: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '154.7%',
    marginBottom: '32px',
    color: black
  },
  alertText: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '154.7%',
    color: yellowThr
  },
  balanceText: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '154.7%',
    color: blackSec
  },
  instructionText: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '154.7%',
    textAlign: 'center',
    letterSpacing: '0.01em',
    color: grayText
  },
  checkboxText: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '154.7%',
    textDecoration: 'underline',
    color: purpleDark
  }
}
